/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Slider } from '@radix-ui/themes';

import { useCallback, useEffect, useRef } from 'fierry/react';


const OnValueChange = (value, latest, onValueChange) =>
{
  latest.current = value;

  onValueChange?.(value);
};


export default ({ onValueChange, onValueCommit, ...props }) =>
{
  const latest = useRef(null);

  useEffect(() =>
  {
    const onCommit = () =>
    {
      if (latest.current !== null)
      {
        onValueCommit?.(latest.current);

        latest.current = null;
      }
    };

    window.addEventListener('pointerup', onCommit);
    window.addEventListener('pointercancel', onCommit);
    window.addEventListener('keyup', onCommit);

    return () =>
    {
      window.removeEventListener('pointerup', onCommit);
      window.removeEventListener('pointercancel', onCommit);
      window.removeEventListener('keyup', onCommit);
    };

  }, [ onValueCommit ]);

  const onChange = useCallback(OnValueChange, [ latest, onValueChange ]);

  return <Slider {...props} onValueChange = {onChange} />;
};
